import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styles from './MetricsGraph.module.css';
import { BACKEND_URL } from '../config';

export default function MetricsGraph({ range }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (range === 'today') { setData([]); setLoading(false); return; }
    setLoading(true);
    fetch(`${BACKEND_URL}/api/report/metrics/trend?range=${range}`, {headers:{'Authorization':`Bearer ${sessionStorage.getItem('token')}`}})
      .then(r => r.json())
      .then(d => { setData(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  }, [range]);

  if (range === 'today') return null;
  if (loading) return <p className={styles.loadingText}>Loading chart...</p>;

  return (
  <div className={styles.sectionContainer}>
    <div className={styles.metricsGraphContainer}>
      <h3 className={styles.title}>Trends Over Time</h3>

      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="total_orders" stroke="#4F46E5" name="Total Orders" />
          <Line type="monotone" dataKey="delivered_orders" stroke="#22C55E" name="Delivered" />
          <Line type="monotone" dataKey="cancelled_orders" stroke="#EF4444" name="Cancelled" />
          <Line type="monotone" dataKey="pending_orders" stroke="#F59E0B" name="Pending" />
          <Line type="monotone" dataKey="revenue" stroke="#0EA5E9" name="Revenue" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);

}
